import { State } from "@/store/modules/sidebar/index";

const setSidebarFull = (state: State, payload: boolean): void => {
  state.sidebarFull = payload;
};

const setOpenChat = (state: State, payload: boolean): void => {
  state.openChat = payload;
};
const setOpenCall = (state: State, payload: boolean): void => {
  state.openCall = payload;
};
const setOpenOtherReason = (state: State, payload: boolean): void => {
  state.openOtherReason = payload;
};
const setActiveMenu = (state: State, payload): void => {
  state.activeMenu = payload;
};
const setPowerUpsNotifications = (state: State, payload): void => {
  state.powerUpsNotifications = payload;
};
export default {
  setSidebarFull,
  setOpenChat,
  setOpenCall,
  setOpenOtherReason,
  setActiveMenu,
  setPowerUpsNotifications,
};
